export enum CalendarView {
    Agenda = "agenda",
    Day = "day",
    Week = "week",
    Month = "month",
    Quarter = "quarter",
    Year = "Year",
}